import type { CSSProperties } from 'react';

import { useSnackAdEligibility } from '@hooks/useSnackAdEligibility';
import { shouldLoadSnackAds } from '@lib/ads/snack';
import {
  VIDEO_PLAYER_ID,
  VIDEO_PLAYER_RESERVED_HEIGHTS
} from '@lib/ads/snack-video';

interface SnackVideoSlotProperties {
  /** Spacing around the slot, which only takes effect while it shows. */
  className?: string;
}

const RESERVED_HEIGHT_STYLE = {
  '--snack-video-mobile-height': VIDEO_PLAYER_RESERVED_HEIGHTS.mobile,
  '--snack-video-desktop-height': VIDEO_PLAYER_RESERVED_HEIGHTS.desktop
} as CSSProperties;

/**
 * Snack's video player (FFH-3483): their tag, which the wrapper fills, in a
 * box that reserves the player's height and shows on the same terms as
 * SnackAdSlot.
 *
 * Unlike an ad slot, the tag itself only renders for visitors who get ads. The
 * wrapper stays loaded for the rest of the visit, so a visitor who stops
 * getting them (by becoming a paying member, say) would otherwise still get a
 * player on the next article.
 */
const SnackVideoSlot = ({ className = '' }: SnackVideoSlotProperties) => {
  const shouldLoadAds = shouldLoadSnackAds(useSnackAdEligibility());

  return (
    <div className={`snack-ad-slot ${className}`} style={RESERVED_HEIGHT_STYLE}>
      <div aria-hidden className="snack-video-space" />
      {shouldLoadAds && <div id={VIDEO_PLAYER_ID} className="w-full" />}
    </div>
  );
};

export default SnackVideoSlot;
